import React, { useState } from 'react';
import { Menu as AntMenu, MenuProps } from 'antd-v5';

type MenuItem = Required<MenuProps>['items'][number];
export type ExtendedMenuItem = MenuItem & {
  versions?: string[];
};

interface LevelKeysProps {
  key?: string;
  children?: LevelKeysProps[];
}

export interface CustomMenuProps {
  items: ExtendedMenuItem[];
  onSelect: MenuProps['onSelect'];
  style?: React.CSSProperties;
  className?: string;
  mode?: MenuProps['mode'];
  selectedKeys?: string[];
}

export const Menu = ({ onSelect, mode = 'inline', items, style, className, selectedKeys }: CustomMenuProps) => {
  const getLevelKeys = (items1: LevelKeysProps[]) => {
    const key: Record<string, number> = {};
    const func = (items2: LevelKeysProps[], level = 1) => {
      items2.forEach((item) => {
        if (item.key) {
          key[item.key] = level;
        }
        if (item.children) {
          func(item.children, level + 1);
        }
      });
    };
    func(items1);
    return key;
  };

  const onOpenChange: MenuProps['onOpenChange'] = (openKeys) => {
    const currentOpenKey = openKeys.find((key) => stateOpenKeys.indexOf(key) === -1);
    // open
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);

      setStateOpenKeys(
        openKeys
          // remove repeat key
          .filter((_, index) => index !== repeatIndex)
          // remove current level all child
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey]),
      );
    } else {
      // close
      setStateOpenKeys(openKeys);
    }
  };
  const [stateOpenKeys, setStateOpenKeys] = useState<string[]>([]);
  const levelKeys = getLevelKeys(items as LevelKeysProps[]);

  return (
    <AntMenu
      mode={mode}
      openKeys={stateOpenKeys}
      onOpenChange={onOpenChange}
      items={items}
      onSelect={onSelect}
      selectedKeys={selectedKeys}
      style={style}
      className={className}
    />
  );
};
